import { render, staticRenderFns } from "./sync-history-one-batch.vue?vue&type=template&id=7f978279&scoped=true&"
import script from "./sync-history-one-batch.vue?vue&type=script&lang=js&"
export * from "./sync-history-one-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f978279",
  null
  
)

export default component.exports